import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumbDetail = _resolveComponent("BreadCrumbDetail")!
  const _component_PermissionsContent = _resolveComponent("PermissionsContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumbDetail, {
      PageTitle: _ctx.t('breadCrumb.permissionsList')
    }, null, 8, ["PageTitle"]),
    _createVNode(_component_PermissionsContent)
  ], 64))
}